import { render } from "./KYC.vue?vue&type=template&id=6090d816&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"

import "./KYC.vue?vue&type=style&index=0&id=6090d816&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6090d816"]])

export default __exports__